import React from 'react';
import { StyleSheet } from 'react-native';
import LineGraph from '../../../../graphs/LineGraph';
import SpaceUtilizationWidget from './SpaceUtilizationWidget';
import OccupancyIcon16 from '../../../16pxIcons/OccupancyIcon16';
import { ChartDataPoint } from '../../../../graphs/axisUtils';

interface AverageOccupancyLineGraphProps {
  title: string,
  chartData: ChartDataPoint[],
  alternateData?: ChartDataPoint[],
  comparisonData?: ChartDataPoint[],
  withCount?: boolean,
}

const AverageOccupancyLineGraph = ({
  title, chartData, alternateData, comparisonData, withCount,
}: AverageOccupancyLineGraphProps) => {
  const filteredData: number[] = withCount
    ? chartData?.map((point: ChartDataPoint) => point.value)
      .filter((value: number) => value >= 0) ?? [] : [];
  const count: number = withCount ? Math.round(
    filteredData.reduce((total: number, value: number) => total + value, 0) / filteredData.length,
  ) : null;
  const filteredComparisonData: number[] = withCount
    ? comparisonData?.map((point: ChartDataPoint) => point.value)
      .filter((value: number) => value >= 0) ?? [] : [];
  const countCompared: number = withCount ? Math.round(
    filteredComparisonData
      .reduce((total: number, value: number) => total + value, 0) / filteredComparisonData.length,
  ) : null;

  return <SpaceUtilizationWidget
    {...{ title, count, countCompared }}
    unit={withCount ? 'ppl' : null}
    icon={<OccupancyIcon16 />}
    label={withCount ? 'Average occupancy over time period' : null}
    tooltipText='Shows average occupancy for each time period during the selected date range'
    content={<LineGraph
      style={[styles.lineGraph, !!alternateData && styles.lineGraphWithLegend]}
      {...{
        title, chartData, alternateData, comparisonData,
      }}
      noTitle
      alternateTitle='Queue'
      horizontalTickCount={7}
      showLegend={!!alternateData}
    />}
  />;
};

const styles = StyleSheet.create({
  lineGraph: {
    marginTop: -80,
  },
  lineGraphWithLegend: {
    marginBottom: -12,
  },
});

export default AverageOccupancyLineGraph;
